module.exports = __webpack_public_path__ + "static/car-e6da4556c3983fce07106e06aaf2eb7f.svg";